<template>
  <div class="container">
    <div class="title">
      <svg viewBox="0 0 5 1" preserveAspectRatio="xMinYMin meet" id="title-svg">
        <text x="0" y="0.9" fill="rgb(21, 101, 96)" font-size="1">
          Cumulative BP
        </text>
      </svg>
      <button
        class="image-button hypo-config-button"
        @click="clickConfig"
      ></button>
    </div>
    <div class="cumulatives">
      <div class="cumulative target">
        <svg viewBox="0 0 3.323 1" preserveAspectRatio="xMinYMin meet">
          <text x="0.14" y="0.3" font-size="0.22">
            {{ levels[0][0] }} (Current Target)
          </text>
          <text x="3.1" y="0.8" font-size="0.5" text-anchor="end">
            {{ levels[0][1] }}
          </text>
        </svg>
      </div>

      <div class="cumulative mild" :style="{ backgroundColor: mildHypoColor }">
        <svg viewBox="0 0 3.323 1" preserveAspectRatio="xMinYMin meet">
          <text x="0.14" y="0.3" font-size="0.22">{{ levels[1][0] }}</text>
          <text x="3.1" y="0.8" font-size="0.5" text-anchor="end">
            {{ levels[1][1] }}
          </text>
        </svg>
      </div>

      <div
        class="cumulative severe"
        :style="{ backgroundColor: severeHypoColor }"
      >
        <svg viewBox="0 0 3.323 1" preserveAspectRatio="xMinYMin meet">
          <text x="0.14" y="0.3" font-size="0.22">{{ levels[2][0] }}</text>
          <text x="3.1" y="0.8" font-size="0.5" text-anchor="end">
            {{ levels[2][1] }}
          </text>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    levels: {
      type: Array,
      required: false,
      default() {
        return [
          ['65 - 80 mmHg', '60 mins'],
          ['55 - 65 mmHg', '20 mins'],
          ['< 55 mmHg', '5 mins']
        ]
      }
    },
    mildHypoColor: {
      type: String,
      default: '#c4c4c4'
    },
    severeHypoColor: {
      type: String,
      default: '#707070'
    }
  },
  methods: {
    clickConfig() {
      this.$emit('toggle-hypo-config')
    }
  }
}
</script>

<style scoped>
svg {
  display: block;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.image-button {
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
  border: none;
  background-color: transparent;
}
.hypo-config-button {
  width: 12%;
  margin-top: 1.5%;
  background-image: url('../assets/SettingsGear.svg');
}
.container {
  height: 100%;
  width: 100%;
  fill: black;
}
.title {
  height: 12%;
  margin: 0;
  padding: 0 0 0 5%;
  display: flex;
  justify-content: flex-start;
  box-sizing: border-box;
}
#title-svg {
  width: 85%;
}
.cumulatives {
  height: 84%;
  width: 100%;
  padding: 3% 3% 3% 5.5%;
  box-sizing: border-box;
}
.cumulative {
  height: 32%;
  width: 100%;
}
.cumulative.target {
  background-color: #c5eecd;
  box-sizing: border-box;
}
.cumulative.mild {
  margin-top: 4%;
}
.cumulative.severe {
  fill: white;
  margin-top: 4%;
}
p {
  margin: 0;
  padding: 0;
}
</style>
